<template>
  <div class="m-filters-settings">
    <sorting
      :id="id"
      :layer-style="layerStyle"
      :layer-controller="layerController"
    />
    <filters
      style="margin-top: 16px;"
      :id="id"
      :layer-style="layerStyle"
      :layer-controller="layerController"
    />
  </div>
</template>

<script>
import Filters from "./filters";
import Sorting from "../sorting/sorting";

export default {
  components: {
    Filters,
    Sorting
  },
  props: ["id", "layer-style", "layer-controller"]
};
</script>

<style></style>
